import { useMemo } from "react";
import useMitreCategories from "security-app/components/SecurityEvents/Alerts/MitreCategories/useMitreCategories";
const useMitreTactics = () => {
  const { data, isInitialLoading } = useMitreCategories();
  const tactics = useMemo(
    () => {
      var _a;
      return (_a = data == null ? void 0 : data.tactics) == null ? void 0 : _a.map((tactic) => [tactic.id, tactic.name]);
    },
    [data == null ? void 0 : data.tactics]
  );
  return {
    tactics,
    isLoadingTactics: isInitialLoading
  };
};
export default useMitreTactics;
